module.exports = __webpack_public_path__ + "img/delivered_truck.a9ce6f80.svg";